import React from "react";

export default function Footer({ onLegal }) {
  return (
    <footer className="bg-[#ebe6e8]">
      <div className="max-w-[1024px] mx-auto px-6 lg:px-0 lg:pl-[48px] lg:pr-[48px] py-[30px] flex flex-col md:flex-row md:items-center justify-end gap-4">
        <div className="flex items-center gap-3 text-[14.5px] text-[#4a4246]">
          <button className="foot-link" onClick={() => onLegal("privacy")} data-testid="footer-privacy">Privacy</button>
          <span className="text-[#9b9397]">|</span>
          <button className="foot-link" onClick={() => onLegal("terms")} data-testid="footer-terms">Terms</button>
          <span className="text-[#9b9397]">|</span>
          <button className="foot-link" onClick={() => onLegal("contact")} data-testid="footer-contact">Contact</button>
        </div>
      </div>
    </footer>
  );
}
